import { SxProps, Theme } from '@mui/material';

export const SearchStoreFormSX: Record<string, SxProps<Theme>> = {
	searchStoreInputContainer: {
		width: '100%',
		'>.MuiInputBase-root': {
			mb: 1,
			pr: '0',
		},
		input: {
			p: '5px 10px',
			pr: 0,
		},
	},
	inputAdorment: {
		maxHeight: '100%',
		height: '100%',
		ml: 0,
		'.was-search-icon': {
			backgroundColor: 'primary.main',
			color: 'white',
		},
	},
	iconContainer: {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		padding: '8px',
		ml: '5px',
	},
};
